import * as yup from "yup"
import {
  Frequency,
  FundamentalsPeriodicity,
  FundamentalsSource,
  FundamentalsTransformationType,
  OutputTransformation,
  Source,
} from "../types/dashboard"

export const DashboardItemSchema = yup.object({
  dataset_id: yup.number().integer().notRequired(),
  dataset_name: yup.string().notRequired(),
  dataset_long_name: yup.string().notRequired(),

  company_id: yup.number().integer().notRequired(),
  company_main_instrument_ticker: yup.string().notRequired(),
  fundamentals_source: yup.string().oneOf(Object.values(FundamentalsSource)).notRequired(),
  fundamentals_periodicity: yup
    .string()
    .oneOf(Object.values(FundamentalsPeriodicity))
    .notRequired(),
  fundamentals_metric: yup.string().notRequired(),
  fundamentals_transformation: yup
    .string()
    .oneOf(Object.values(FundamentalsTransformationType))
    .notRequired(),
  output_transformation: yup.string().oneOf(Object.values(OutputTransformation)).notRequired(),
})

export const DashboardUpdateCreateSchema = yup.object({
  name: yup.string().required("Name is required"),
  items: yup
    .array()
    .of(DashboardItemSchema)
    .min(1, "At least one item is required")
    .max(100, "Maximum of 100 items allowed")
    .required(),
  zScore: yup.boolean().default(false),
  backtest: yup.boolean().default(true),
  source: yup.string().oneOf(Object.values(Source)).default(Source.OBSERVED),
  freq: yup.string().oneOf(Object.values(Frequency)).default(Frequency.MONTHLY),
})
